import {MulliganRouter} from '../../routes';
import React from 'react';

export default {

  toHTML(string) {
    return (<span dangerouslySetInnerHTML={{__html: string}} />);
  },

  toDateString(string) {
    let date = new Date(string);
    return `${date.getMonth()+1}/${date.getDate()}/${(date.getFullYear()+"").substring(2,4)}`;
  },

  getCurrencySymbol(currency) {
    return {
      "GBP" : "£",
      "ZAR" : "R"
    }[currency] || "$";
  },

  transactionSubtotal(transaction) {
    return transaction.purchaseItems.map((item) => {
      return parseFloat(item.itemPrice) * item.quantity;
    }).reduce((a, b) => {
      return a + b;
    }, 0);
  },

  _itemPrice(item, currency, withTax) {
    let price = Math.abs(parseFloat(item.itemPrice));

    if(currency === 'GBP' || currency === 'AUD' || withTax){
      // the price has to include VAT
      price += item.tax;
    }

    return price;
  },

  vat(currency) {
    switch (currency) {
      case 'GBP':
        return 'VAT';
      case 'AUD':
        return 'GST';
      default:
        return false;
    }
  },

  taxRate(floatString) {
    let rate = (100 * parseFloat(floatString));
    rate = rate.toFixed(3);
    // Removes trailing zeros
    return parseFloat(rate).toString();
  },

  getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  },

  // http://stackoverflow.com/questions/1634748/how-can-i-delete-a-query-string-parameter-in-javascript
  removeParameter(url, parameter) {
      //prefer to use l.search if you have a location/link object
      var urlparts= url.split('?');
      if (urlparts.length>=2) {

          var prefix= encodeURIComponent(parameter)+'=';
          var pars= urlparts[1].split(/[&;]/g);

          //reverse iteration as may be destructive
          for (var i= pars.length; i-- > 0;) {
              //idiom for string.startsWith
              if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                  pars.splice(i, 1);
              }
          }

          url= urlparts[0]+'?'+pars.join('&');
          return url;
      } else {
          return url;
      }
  },

  addParameter(url, parameter, value) {
    parameter = encodeURIComponent(parameter);
    value = encodeURIComponent(value);
    if (url.indexOf('?') === -1){
      return url + "?" + parameter + "=" + value;
    } else {
      var parts = url.split('?');
      return parts[0] + "?" + parameter + "=" + value + "&" + parts[1];
    }
  },

  inlineSVG(path) {
    return this.toHTML(require("!svg-inline-loader?removeSVGTagAttrs=false!../../img/transactions.svg"));
  },

  isValidEmail(email) {
    let emailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return email.match(emailformat);
  },

  redraw(){
    // This is how the cool kids redraw these days
    Routes.init('/');
  },

  printReceipt() {
    var contentRightHeight = document.getElementById('content-right').scrollHeight;
    document.getElementById("content-right").style.height = `${contentRightHeight}px`;
    window.print();
    document.getElementById("content-right").style.height = "";
  }

}
